import { createQueryKeys } from '../../factories';

export const NESTED_BREADCRUMB_NAMESPACE = ['resource', 'breadcrumbs'];

export const nestedBreadcrumbQueryKeyFactory = createQueryKeys(
	NESTED_BREADCRUMB_NAMESPACE
);
